import React, { useState } from 'react';
import './GalleryCard.css';

const GalleryCard = ({ gallery, onDelete, onEdit, onViewPhotos }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (window.confirm(`Are you sure you want to delete "${gallery.category_title}"?`)) {
      setIsDeleting(true);
      try {
        await onDelete(gallery.gallery_category_id);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const defaultImage = 'https://via.placeholder.com/400x300?text=No+Image';
  const imageUrl = gallery.category_image || defaultImage;

  return (
    <div className="gallery-card">
      <div className="gallery-card-image">
        <img 
          src={imageUrl} 
          alt={gallery.category_title}
          onError={(e) => { e.target.src = defaultImage; }}
        />
        <span className={`status-badge ${gallery.display_status === '1' ? 'active' : 'inactive'}`}>
          {gallery.display_status === '1' ? 'Active' : 'Inactive'}
        </span>
      </div>
      
      <div className="gallery-card-content">
        <h3 className="gallery-title">{gallery.category_title}</h3>
        <p className="gallery-location">
          <i className="icon-location"></i>
          {gallery.category_location || 'No location'}
        </p>
        <div className="gallery-meta">
          <span className="meta-item">Order: {gallery.category_order || 0}</span>
          <span className="meta-item">
            {new Date(gallery.upload_date).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
            })}
          </span>
        </div>
      </div>

      <div className="gallery-card-actions">
        <button
          className="btn btn-view"
          onClick={() => onViewPhotos(gallery.gallery_category_id)}
          disabled={isDeleting}
          title="View photos"
        >
          View Photos
        </button>
        <button
          className="btn btn-edit"
          onClick={() => onEdit(gallery.gallery_category_id)}
          disabled={isDeleting}
          title="Edit gallery"
        >
          Edit
        </button>
        <button
          className="btn btn-delete"
          onClick={handleDelete}
          disabled={isDeleting}
          title="Delete gallery"
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </div>
  );
};

export default GalleryCard;
